import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import { BeatLoader } from "react-spinners";

class CrispMerchantMobileFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileList: [],
            selectedMobiles: [],
            isLoading: true,
            isListOpen: false,
            headerTitle: "Select [Mobile]",
            searchQuery: ""
        };
        this.closeDropdown = this.closeDropdown.bind(this);
    }

    componentDidMount() {
        this.fetchMobiles(false, "");
        window.addEventListener("click", this.closeDropdown);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.closeDropdown);
    }

    fetchMobiles(isSearch = false, searchQuery = "") {
        if(isSearch===false){
            this.setState({
                selectedMobiles:[]
            })
        }
        this.setState({ isLoading: true });
        axios
            .post(config.get("API_URL") + "/filters/get-crisp-merchant-mobiles", {
                search_query: searchQuery,
                selected_values: this.state.selectedMobiles.map(item => item.value)
            }, {
                headers: { Authorization: ` ${localStorage.usertoken}` }
            })
            .then((response) => {
                let mobiles = response.data.map((item) => ({
                    value: item.mobile || "NA",
                    label: item.mobile || "NA",
                }));
                const selected = (this.props.value || []).map(val => ({
                    value: val,
                    label: val
                }));
                this.setState({
                    mobileList: mobiles,
                    isLoading: false,
                    selectedMobiles: selected
                });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ isLoading: false });
            });
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({ isListOpen: !prevState.isListOpen }));
    };

    closeDropdown(e) {
        if (this.dropdownRef && !this.dropdownRef.contains(e.target)) {
            this.setState({ isListOpen: false });
        }
    }

    handleSearch = (e) => {
        const query = e.target.value;
        this.setState({ searchQuery: query });
        setTimeout(() => this.fetchMobiles(true, query), 300);
    };

    handleSelect(item, checked) {
        let selected = [...this.state.selectedMobiles];
        if (checked) {
            selected.push(item);
        } else {
            selected = selected.filter((i) => i.value !== item.value);
        }
        this.setState({ selectedMobiles: selected });
        this.props.onSelectCrispMerchantMobile(
            selected,
            selected.map((s) => s.value)
        );
    }
    removeCrispMerchantMobile = () => {
        const val = '';
        this.props.onSelectCrispMerchantMobile(val);
        this.setState({
            selectedMobiles: [],
            mobileList: [],
            searchQuery: ""
        });
    };

    render() {
        const { mobileList, selectedMobiles, isListOpen, isLoading } = this.state;
        return (
            <div className="dd-wrapper" ref={(ref) => (this.dropdownRef = ref)}>
                <div className="dd-header" onClick={this.toggleDropdown}>
                    {selectedMobiles.length === 0 ? (
                        <div className="dd-header-title">Select [Mobile]</div>
                    ) : (
                        <div className="dd-header-title">{selectedMobiles.length} Selected</div>
                    )}
                    <i className="fa fa-angle-down"></i>
                </div>

                {isListOpen && (
                    <div role="list" onClick={(e) => e.stopPropagation()}>
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            value={this.state.searchQuery}
                            onChange={this.handleSearch}
                        />
                        <ul className="dd-list">
                            {isLoading ? (
                                <li>
                                    <BeatLoader size={5} color="#666" loading={true} />
                                </li>
                            ) : (
                                mobileList.map((item, index) => {
                                    const checked = selectedMobiles.some((s) => s.value === item.value);
                                    return (
                                        <li
                                            key={index}
                                            className={`dd-list-item ${checked ? "dd-list-active" : ""}`}
                                            onClick={() => this.handleSelect(item, !checked)}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                readOnly
                                            />
                                            &nbsp;&nbsp;{item.label}
                                        </li>
                                    );
                                })
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default CrispMerchantMobileFilter;
